module.exports = __webpack_public_path__ + "static/img/fangzhiBg.5c61f670.png";